import tw from "tailwind-styled-components";
const Footer = () => {
    return (
        <FooterCss>
            <div className="max-w-5xl mx-auto py-4">

                <div className="text-center text-xs text-gray-400">
                    © {new Date().getFullYear()} Kipinn. All rights reserved.
                </div>
            </div>
        </FooterCss>
    )
}
export default Footer

const FooterCss = tw.footer`
  bg-white 
  border-t border-gray-100 
`;